const CommonContainer = ({children}) => {
    return (
        <div className="" style={{ paddingLeft: 50, paddingRight: 50, paddingTop: 30, height: '100%', backgroundColor: '#fff'}}>
            {children}
        </div>
    )
}

export default CommonContainer;